import { useSideCart } from '@hooks/cart/useShoppingCart';
import CharacterHappy from '@monofront/design-system/visuals/Illustrations/CharacterHappy';
import InformativeBox from '@monofront/design-system/components/InformativeBox';
import { useEffect } from 'react';
import { RichText } from 'prismic-reactjs';
import { PrismicRichTextInjecter } from '@monofront/slice-machine/helpers';
import { useEligibility } from '@monofront/business/contexts';
import HeartLoader from '@monofront/design-system/components/HeartLoader';
import PrismicLink from '@components/PrismicLink';
import { IPrismicProductEligibilityModal } from './types';
import {
  SlicesContainer,
  SlicesContainerLayoutType,
} from '@screens/SlicesContainer';

interface IFreshAddressEligibleProps {
  document?: IPrismicProductEligibilityModal;
}

const FreshAddressEligible: React.FC<IFreshAddressEligibleProps> = ({
  document,
}) => {
  const { address } = useEligibility();
  const { sideCart, dispatchSideCart } = useSideCart();

  useEffect(() => {
    const addToCart = async () => {
      if (sideCart.addFreshProductToCart) {
        await sideCart.addFreshProductToCart();
      }

      if (sideCart.addFreshProductsToCart) {
        await sideCart.addFreshProductsToCart();
      }
    };

    addToCart();
  }, []);

  if (!document) return <HeartLoader />;

  return (
    <>
      <InformativeBox
        hasPadding={false}
        backgroundColor="transparent"
        hasImageOnMobile
        icon={<CharacterHappy aria-hidden="true" />}
      >
        <RichText
          render={document.eligible_informative_box_text}
          htmlSerializer={PrismicRichTextInjecter({
            '%ADDRESS%': `${address?.postalCode}, ${address?.city}`,
          })}
        />
      </InformativeBox>

      <section className="[&_.slice-container]:tw-border-0 [&_.slice-container]:tw-border-t [&_.slice-container]:tw-border-solid [&_.slice-container]:tw-border-t-blue-200 [&_.slice-container]:tw-py-4">
        <SlicesContainer
          pageContents={document.body}
          layout={SlicesContainerLayoutType.INSIDE}
        />
      </section>

      <section className="tw-mb-[140px] [&>p]:tw-border-0 [&>p]:tw-border-t [&>p]:tw-border-solid [&>p]:tw-border-t-blue-200 [&>p]:tw-py-4">
        <RichText render={document.eligible_text} />
      </section>

      <div className="tw-fixed tw-bottom-0 tw-left-0 !tw-m-0 tw-h-[140px] tw-w-full tw-bg-red-100 tw-px-3 tw-py-4">
        <button
          data-testid="FreshAddressEligible-continue-button"
          className="tw-lf-button tw-lf-button-primary tw-lf-button-md tw-my-2 tw-w-full "
          onClick={() => dispatchSideCart({ type: 'close' })}
        >
          {document.close_modal_cta_label}
        </button>
        <PrismicLink
          link={document.go_to_shelf_link}
          className="tw-lf-button tw-lf-button-secondary tw-lf-button-md tw-my-2 tw-bg-white"
        >
          {document.go_to_shelf_cta_label}
        </PrismicLink>
      </div>
    </>
  );
};

export default FreshAddressEligible;
